export const servicePriceToNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const price = Number(
    String(value).replace("R$", "").replace(/\./g, "").replace(",", ".").trim()
  );

  return Number.isNaN(price) ? null : price;
};

export const isFreeServicePrice = (value) => servicePriceToNumber(value) === 0;

export const hasServicePrice = (value) => {
  const price = servicePriceToNumber(value);

  return price !== null && price > 0;
};
